import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { PayPalIcon } from '@karma/components/icons';
import { Button, Stack, Typography } from '@karma/components';
import * as ALOOMA from 'consts/alooma';
import Alooma from 'services/alooma';
import withIosBugFixCaret from 'hocs/withIosBugFixCaret';
import { oldApiInstance } from 'functions/request';
import useAction from 'hooks/useAction';
import { showErrorAlert, showSuccessAlert } from 'store/alerts/actions';

const ModalBodyWithdrawPaypalBlockedByGiftCard = ({ closeModal, iosBugHideHandler, iosBugShowHandler }) => {
  const [loading, setLoading] = useState();
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const showSuccessAlertFunc = useAction(showSuccessAlert);
  const showErrorAlertFunc = useAction(showErrorAlert);

  const close = () => {
    iosBugHideHandler();
    closeModal();
  };

  const cancelGiftCardHandler = async () => {
    setLoading(true);

    try {
      await oldApiInstance.post('/plus/cancel_withdrawal');
      showSuccessAlertFunc({ message: 'app:success' });
      close();
    } catch (e) {
      showErrorAlertFunc({ message: 'app:pleaseTryAgain' });
      setLoading(false);
    }
  };

  useEffect(() => {
    iosBugShowHandler();
  }, [iosBugShowHandler]);

  return (
    <Stack direction="column" spacing={20}>
      <PayPalIcon width={60} height={60} />
      <Stack direction="column" spacing={8}>
        <Typography variant="h3">{t('app:canNotCashOut')}</Typography>
        <Typography variant="paragraphLarge">{t('app:youHaveGiftCardRedemptionProgress')}</Typography>
      </Stack>
      <Button
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.CANCEL_GIFT_CARD}
        size="medium"
        onClick={cancelGiftCardHandler}
        fullWidth
        loading={loading}
      >
        {t('app:cancelGiftCard')}
      </Button>
      <Button
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.DISMISS}
        type="outline"
        size="medium"
        onClick={close}
        fullWidth
      >
        {t('app:dismiss')}
      </Button>
    </Stack>
  );
};

ModalBodyWithdrawPaypalBlockedByGiftCard.propTypes = {
  closeModal: PropTypes.func.isRequired,
  iosBugHideHandler: PropTypes.func.isRequired,
  iosBugShowHandler: PropTypes.func.isRequired,
};

export default withIosBugFixCaret()(ModalBodyWithdrawPaypalBlockedByGiftCard);
